import { defaultTheme, PrestyledTheme } from '../default';
import { styles, fonts, fontSizes, fontWeights, lineHeights, letterSpacings, text } from './typography';
import { colors } from './colors';
export const portfolioBlueTheme: PrestyledTheme = {
  ...defaultTheme,
  colors,
  styles,
  fonts,
  fontSizes,
  fontWeights,
  lineHeights,
  letterSpacings,
  text,
};
